export const CONTACT_TEXT_MAX = 255;
const TEXT_RE = /^[^\x00-\x1F\x7F]*$/;

export function duplicateUpdatedToast(data: any): { title: string; description?: string } {
  const number = data?.contactGroupMember?.primary_number ?? data?.previous?.primary_number;
  return {
    title: `${number} already existed — contact updated${data?.linked ? ' and added to group' : ''}.`,
  };
}

export function contactFieldError(_name: string, label: string, value: string): string | null {
  if (value.length > CONTACT_TEXT_MAX) return `${label} must be at most ${CONTACT_TEXT_MAX} characters`;
  if (!TEXT_RE.test(value)) return `${label} must not contain control characters`;
  return null;
}
